var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_301187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#DCC0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2 0C344.2 38 260.1 49.8 236.3 93.7C176.1 204.8 103 204.4 0 194.7V0H356.2Z",
    fill: "#DDB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 287.2V500H0V417.4C99.7 331 238.3 418.2 500 287.2Z",
    fill: "#DDB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.9 206.9C436 241.4 403.6 273.9 368.5 303.2C340.3 326.5 310.2 347.8 277.3 364C276.7 364.3 275.6 364.8 275 365.1C274.5 365.1 274.1 364.5 273.7 364.1C273.1 363.5 272 362 271.5 361.9C271.1 361.2 274 367.7 272.7 365L272.5 365.1L272.2 365.3C229.4 387.2 176.5 400.9 130.4 379.5C68.4 350.7 40.8 268.5 55.2 204.4C68.4 154.5 114.9 116.2 160.1 95.6C165.9 93 171.8 90.6 177.8 88.4C179.8 87.7 182.6 86.8 184.6 86.2C198 82.7 211.7 90.8 215.2 104.2C219 118.3 209.6 132.6 195.5 135.2C157.1 146.3 119.4 168.6 98.5 203.3C87.5 223.6 87.5 250.8 91.1 273.6C97.6 312.9 120.7 351.2 160.9 362.4C194.8 372.2 232 363 264.2 349.8L264.8 349.5L265.1 349.4L265.3 349.3C264.1 346.6 267.1 353 266.9 352.2C267.1 351.8 266.7 349.9 266.6 349.1C266.6 348.5 266.2 347.5 266.9 347.3C272.5 344.7 278.1 342 283.6 339.1C343 307.3 395 263 444.7 217.9L461.4 202.5C462.7 201.3 464.7 201.4 465.8 202.7C466.9 203.9 466.9 205.7 465.9 206.9Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.4 441.4C336.282 441.4 390.5 427.655 390.5 410.7C390.5 393.745 336.282 380 269.4 380C202.518 380 148.3 393.745 148.3 410.7C148.3 427.655 202.518 441.4 269.4 441.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367.9 210.5C362.2 178.4 305.9 160.3 237.1 172.7C168.3 185 121.4 218.6 127.1 250.7L179 394C183.4 418.3 229.2 430.5 281.5 421.1C333.8 411.7 372.6 384.4 368.2 360.1L367.9 210.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.4 204.7C356 207.8 355.9 211 355.2 214.2C350 239.1 308.7 264.7 255.3 274.3C201.9 283.9 154.2 274.2 140.7 252.6C138.9 249.9 137.8 246.9 137.2 243.8C132.3 216.2 177.1 185 237.4 174.2C297.7 163.4 350.4 177.1 355.4 204.7Z",
    fill: "#64327A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.2 214.2C351.3 232.7 327.5 252.1 293.6 264.8C281.9 269.2 269 272.7 255.3 275.2C247.2 276.7 239.1 277.7 231.3 278.2C202.3 280.3 176.6 276.3 159.3 268C150.8 263.9 144.4 258.7 140.6 252.7C150.7 243.4 157.6 235.4 171.2 227.3C185.4 218.9 197.8 211 239.9 195.9C293.9 176.4 359.8 181.3 355.2 214.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.5 338.4L359.2 345.6C356 346.2 352.8 345.5 350.4 343.9C348 342.3 346.6 339.8 346.6 337.1L346.3 245.2C346.3 240.6 350.3 236.4 355.7 235.5L394.6 228.5C397.6 227.8 407.6 226 416.6 230.5C421.6 233 427.9 238.3 429.8 249.3C432.9 266.6 425.9 304.1 422.7 319.4C422 322.7 420.3 325.8 417.8 328.3C414 332.1 407.8 336.9 399.5 338.4ZM368.5 325.1L396.2 320.1C397.2 319.9 399 319 401.1 317C405.7 295 410.2 265.1 408.1 253.2C407.5 249.9 406.3 247.7 404.7 246.8C402.6 245.7 399.4 246.5 399.4 246.5C399 246.6 398.8 246.7 398.3 246.7L368.3 252.1L368.5 325.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.2 206.8C261 206.8 259.8 206.1 259.3 204.9C258.6 203.3 259.4 201.4 261 200.7C301.1 183.8 327.6 200.2 328.7 201C330.2 201.9 330.6 203.9 329.7 205.4C328.8 206.9 326.8 207.3 325.3 206.4C324.9 206.2 300.3 191.2 263.5 206.6C263 206.7 262.6 206.8 262.2 206.8Z",
    fill: "#F8F9FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0V104C484.1 107.2 467.9 114.7 452 128.9C394.4 180.1 305.8 115.1 284.1 140.6C254.6 175.5 255.7 220.8 255.2 220.8C254.6 220.8 230.1 141.1 272.5 102.5C299.2 78.2 324 96 370.4 73.1C402.4 57.3 413 25.9 421 0L500 0Z",
    fill: "#F8F9FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_301187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaffee);
export default __webpack_public_path__ + "static/media/Caffee.3a1273b5.svg";
export { ForwardRef as ReactComponent };